export default "__VITE_ASSET__69cb8253__"